import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "album-item"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "num"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "num"
};
var _hoisted_7 = {
  key: 2,
  class: "check-box"
};
import { MessagePlugin } from 'tdesign-vue-next';
import { ref, watch } from 'vue';
import { giveLike } from '@/api/personalHomepage';
import AlbumViewDialog from './AlbumViewDialog';
export default {
  __name: 'albumItem',
  props: {
    data: {
      type: Object,
      default: function _default() {}
    },
    IdPeople: {
      type: String,
      default: ''
    },
    clickLeftValue: {
      type: String,
      default: ''
    },
    spaceHideFlag: {
      type: Number,
      default: 0
    },
    isCheckModule: {
      type: Boolean,
      default: false
    },
    clickRightValue: {
      type: Number,
      default: 0
    }
  },
  emits: ['like', 'changeFlag'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    var props = __props;
    var albumShow = ref(false);
    var whiteStar = require('@/assets/home/white-star.svg');
    var redStar = require('@/assets/home/red-star.svg');
    var flag = ref(false);
    var disable = ref(false);
    watch(function () {
      return props;
    }, function (val) {
      var data = val.data,
        spaceHideFlag = val.spaceHideFlag;
      if (spaceHideFlag == 1) {
        //1隐藏
        flag.value = data.spaceHideFlag === 1 ? true : false;
        disable.value = data.spaceHideFlag === 1 ? true : false;
      } else {
        //0公开
        flag.value = data.spaceHideFlag === 0 ? true : false;
        disable.value = data.spaceHideFlag === 0 ? true : false;
      }
    }, {
      deep: true,
      immediate: true
    });
    // 查看详情
    var lookDetail = function lookDetail() {
      albumShow.value = true;
    };
    // 更新数据
    var updateStar = function updateStar() {
      emit('like', 'album');
    };
    // 点赞
    var handleLikeClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        var id, isLike, opType, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              id = val.id, isLike = val.isLike;
              _context.p = 1;
              opType = isLike === 0 ? 1 : 0;
              _context.n = 2;
              return giveLike(id, 1, opType);
            case 2:
              emit('like', 'album');
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              MessagePlugin.error('请求失败，请重试');
            case 4:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function handleLikeClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var handleChange = function handleChange(val) {
      console.log(val, '--handleChange');
      emit('changeFlag', props.data.id);
    };
    return function (_ctx, _cache) {
      var _component_t_checkbox = _resolveComponent("t-checkbox");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
        class: "img",
        src: __props.data.cover,
        onClick: lookDetail,
        width: "100%",
        height: "100%",
        alt: ""
      }, null, 8, _hoisted_2), !__props.isCheckModule ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "num-box",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return handleLikeClick(__props.data);
        })
      }, [_createElementVNode("img", {
        src: __props.data.isLike === 0 ? _unref(redStar) : _unref(whiteStar),
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, _toDisplayString(__props.data.likeCount), 1)])) : _createCommentVNode("", true), !__props.isCheckModule ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "num-box",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return handleLikeClick(__props.data);
        })
      }, [_createElementVNode("img", {
        src: __props.data.isLike === 0 ? _unref(redStar) : _unref(whiteStar),
        alt: ""
      }, null, 8, _hoisted_5), _createElementVNode("span", _hoisted_6, _toDisplayString(__props.data.likeCount), 1)])) : _createCommentVNode("", true), __props.isCheckModule && __props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_t_checkbox, {
        modelValue: flag.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return flag.value = $event;
        }),
        disabled: disable.value,
        onChange: handleChange
      }, null, 8, ["modelValue", "disabled"])])) : _createCommentVNode("", true), __props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", {
        key: 3,
        class: _normalizeClass(['tip', __props.data.spaceHideFlag === 1 ? 'hide' : 'open'])
      }, _toDisplayString(__props.data.spaceHideFlag === 1 ? '已隐藏' : '已公开'), 3)) : _createCommentVNode("", true)]), _createVNode(_unref(AlbumViewDialog), {
        visible: albumShow.value,
        "onUpdate:visible": _cache[3] || (_cache[3] = function ($event) {
          return albumShow.value = $event;
        }),
        "picture-id": __props.data.id,
        "Id-people": props.IdPeople,
        "click-left-value": props.clickLeftValue,
        onUpdateStar: updateStar
      }, null, 8, ["visible", "picture-id", "Id-people", "click-left-value"])], 64);
    };
  }
};